/**
 * `LIBERO_CHANGE` zones: `OUT:<libero>` for a swap, `OFF:<libero>` for a libero
 * taken off without replacement (VOL-220). Same marker on the server replay.
 */
export const LIBERO_OFF_PREFIX = 'OFF:';
const LIBERO_OUT_PREFIX = 'OUT:';

export function liberoTakenOffName(zone: string | null | undefined): string | null {
  return zone?.startsWith(LIBERO_OFF_PREFIX) ? zone.slice(LIBERO_OFF_PREFIX.length) : null;
}

export function liberoReplacedName(zone: string | null | undefined): string | null {
  return zone?.startsWith(LIBERO_OUT_PREFIX) ? zone.slice(LIBERO_OUT_PREFIX.length) : null;
}
